import { defineRecipe } from "@chakra-ui/react";

export const badgeRecipe = defineRecipe({
  base: {
    colorPalette: "primary",
  },
  variants: {
    visual: {
      primary: {
        bg: "colorPalette.muted",
        color: "colorPalette.solid",
        whiteSpace: "normal !important",
        wordBreak: "break-word",
        textAlign: "start",
        _hover: {
          bg: "colorPalette.solid",
          color: "colorPalette.muted",
          cursor: "pointer",
        },
      },

      outline: {
        bg: "transparent",
        color: "colorPalette.solid",
        border: "2px solid",
        borderColor: "colorPalette.solid",
        _hover: {
          bg: "colorPalette.solid",
          color: "colorPalette.muted",
        },
      },
    },
    size: {
      custom: {
        fontSize: "2xs",
        px: "1.5",
        minH: "5",
      },
    },
  },
  defaultVariants: {
    visual: "primary",
    size: "custom",
  },
});
